import "@babel/polyfill";
import React from 'react';
import ReactDOM from 'react-dom';

// App
import App from './App';

// Styles
import './assets/styles/style.css';

// Service Workers
import registerServiceWorker from './registerServiceWorker';

// Stripe
import { StripeProvider } from 'react-stripe-elements';

// Redux
import { Provider } from 'react-redux';
import configureStore from './store';
import { PersistGate } from 'redux-persist/es/integration/react'

const { store, persistor } = configureStore()

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
        <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY}>
          <App />
        </StripeProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js